import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Checks back on an AI run that a background job is still working on. Inside
// a turbo-frame it reloads just that frame from the current page; on its own
// it refreshes the page. Either way the fresh HTML only carries this
// controller while the run is still going, so polling stops by itself.
export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 } }

  connect() {
    this.timer = setTimeout(() => this.check(), this.intervalValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  check() {
    const frame = this.element.closest("turbo-frame")
    if (!frame) {
      Turbo.visit(window.location.href, { action: "replace" })
    } else if (frame.src) {
      frame.reload()
    } else {
      frame.src = window.location.href
    }
  }
}
